var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-breadcrumbs',{staticClass:"px-0 py-2",attrs:{"items":_vm.breadcrumbs}}),_c('h2',[_vm._v(" 新規登録（他社運搬） ")]),_c('order-form',{attrs:{"duplicate-order-id":_vm.duplicateOrderId,"callable-type":"proxy_request"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }